import React, { useMemo } from 'react';
import {
  Card,
  CardContent,
  Typography,
  TypographyProps,
} from '@mui/material';
import { IEducationalVideoItem } from '../../../dataObjects/models/educationalVideos';
import { cardGridViewItemStyles } from '../../styles';
import { EducationalVideoMediaDisplay } from '../../controls/digitalMediaDisplays/EducationalVideoMediaDisplay';
import { styled, useTheme } from '@mui/styles';


// a styled Typography for a Section Header
const StyledTypographyForTitle = styled((props: TypographyProps) => (
  <Typography
    variant='h6'
    {...props}
  />
))(({ theme }) => ({
  fontWeight: 'bolder',
  marginLeft: theme.spacing(2),
  marginBottom: theme.spacing(-1),
  color: theme.cardViewCard.titleColor,

  [theme.breakpoints.up('xs')]: {
    fontSize: '1.0rem',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.05rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1.1rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.15rem',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '1.2rem',
  },

}));


export interface IEducationalVideosVideoGridViewItemProps {
  productVideo: IEducationalVideoItem;
}


export const EducationalVideosVideoGridViewItem: React.FC<IEducationalVideosVideoGridViewItemProps> = (props: IEducationalVideosVideoGridViewItemProps) => {

  const { productVideo } = props;

  const classes = cardGridViewItemStyles();

  // memoize the rendering of the video for existing VideoLink so that it won't have to be reset with every render
  const videoObjectForDisplay = useMemo(() => (
    <div className={classes.reactPlayerContainer} >
      <EducationalVideoMediaDisplay videoDisplayViewModel={productVideo} />
    </div>
  ), [classes, productVideo]);

  return (
    <>
      {/* <Card classes={{ root: classes.card }} elevation={6}> */}
      <Card elevation={6} className={classes.card}>

        {/* Note: Couldn't get proper behavior from <CardHeader>, so will just display a title via <Typography> */}
        <StyledTypographyForTitle>
          {productVideo.title}
        </StyledTypographyForTitle>

        <CardContent>

          {videoObjectForDisplay}

          <Typography className={classes.cardDescription} variant="body1">
            {productVideo.description}
          </Typography>
        </CardContent>
        {/* </CardActionArea> */}

      </Card>
    </>
  );

}